import { combineReducers } from "redux";

import { commonReducer } from "./commonReducer";
import { auth, addMagicToken, verifyMagicToken, getCountryCode } from "./auth";
import { userCar,userCarFacilities, userAddCar, userDeleteCar,userUpdateCar,userFacilities } from "./UserCar";
import { userRateCard ,userAddRateCard,userGetTripPrice,userCompanyLocation, userCompanyDuty,userSubCity} from "./UserRateCard";
import { userServiceCity, userServiceRegion, userSubVendorRegion } from "./UserServiceCity";
import { userSubVendor, userDetailSubVendor, userAddSubVendor, userUpdateSubVendor } from "./UserSubVendor";
import { userChooseYourService, userUpdateChooseYourService } from "./UserChooseYourService";
import { addReservation, getReservationDetails, getReservationList , updateReservation,getDownLoadList, getCancelReason, getBookingBufferTime, getAirportTerminalList} from "./reservationReducer";

import {
  userDriver,
  userAddDriver,
  userUpdateDriver,
  userTicketDriver,
  userMatrixDriver,
  userMoreDriver,
} from "./UserDriver";
import {
  userVehicle,
  userAddVehicle,
  userUpdateVehicle,
  userDeleteVehicle,
  userMatrixVehicle,
  userMoreVehicle,
} from "./UserVehicle";
import {
  userRideDetails,
  userRideAnalytic,
  userTotalRegistration,
  userTopCompanies,
  userCompanyTripStats,
  userCompanyData
} from "./UserDashboard";
import { userOurCar } from "./UserTopSection";
import { locationDropdownReducer } from "./UserLocations";

import { addCompany, userCompanyDetails, userCompany, gstCompany, updateCompany, updateGstCompany, parentCompanyList,userParentCompanyDetails } from "./company";
import { getComplianceValidation, userAddCompliance, userAddOnBoardCompliance, userApproveCompliance, userCompliance, userConfigCompliance, userOnBoardCompliance, userUpdateCompliance } from "./UserCompliance";
import { userDutyType } from "./UserDutyType";
import { getEmployeesList } from "./EmployeesReducer";
import { userAddVendor, userUpdateVendor, userVendor,userVendorUser} from "./UserVendor";
import { userAutoComplete, userDirection, userGeocode, userPlaceDetails,userRideDetailsPolylines } from "./UserGoogleMap";
import { allotVehicle, getAvailableVehicle, getAvailableSuppliers, cancelTrip, dispatchVehicle, getCancelTripCharges } from "./OperationsReducer";
import { getSettlementDetails, getSettlementList, updateSettlement,addSettlement,getConsolidateInvoiveList } from "./SettlementReducer";
import { userProfile, userUpdateProfile } from "./SettingsReducer";
import { userAssignVehicle, userListAssignedVehicle, userRequestVehicle, userUpdateAssignDriver, userUpdateAssignVehicle,userAssignDriver,userUpdateAssignSubVendor } from "./UserAllot";
import { addBillingConsolidatedInvoice, addBillingRequestApproval, getBillingChargesCalculations, getBillingConsolidatedInvoiceDetails, getBillingInvoiceDetails, getBillingList, getBillingPriceDetails, getConsolidateInvoiceMatrix, getFinalInvoice, addBillingRequestApprovalLink } from "./BillingReducer";
import { getBookingMatrix,getBookingReportList,getCustomerMatrix,getCustomerList,getRevenueList ,getRevenueMatrix,getRevenueDownLoad, getMisList,getMisReportDownLoad} from "./ReportsReducer";
import userLogout from "./UserLogout";
import { getRolesAndPermissions,getSupplierRole } from "./RolesAndPermissionsReducer";
import { getAdminUser, userAddAdminUser, userUpdateAdminUser } from "./AdminUserReducer";
import { userAddTag, userRating, userTag, userUpdateTag } from "./UserTag";
import { userAddFaq, userDeleteFaq, userFaq, userFaqSection, userUpdateFaq } from "./UserFAQ";
import { userNotification, userNotificationCount, userNotificationSeen } from "./UserNotification";
import { userCustomerComplaints } from "./UserCustomerComplaints";
import { userCustomer, userMatrixCustomer, userTicketCustomer, userUpdateCustomer } from "./UserCustomer";
import { userCoupon, userAddCoupon, userUpdateCoupon, userDeleteCoupon } from "./UserCouponReducer";

const rootReducer = combineReducers({
  commonReducer: commonReducer,
  auth: auth,
  getCountryCode: getCountryCode,
  getRolesAndPermissions: getRolesAndPermissions,
  userOurCar: userOurCar,
  userRideDetails: userRideDetails,
  userRideAnalytic: userRideAnalytic,
  userTotalRegistration: userTotalRegistration,
  addCompany: addCompany,
  userCompany: userCompany,
  parentCompanyList: parentCompanyList,
  userCompanyDetails: userCompanyDetails,
  getEmployeesList: getEmployeesList,
  userDutyType: userDutyType,
  userCar: userCar,
  userRateCard: userRateCard,
  userAddRateCard: userAddRateCard,
  userServiceCity: userServiceCity,
  userServiceRegion: userServiceRegion,
  userSubVendorRegion: userSubVendorRegion,
  userSubVendor: userSubVendor,
  userDetailSubVendor: userDetailSubVendor, 
  userAddSubVendor: userAddSubVendor, 
  userUpdateSubVendor: userUpdateSubVendor,
  userVehicle: userVehicle,
  userAddVehicle: userAddVehicle,
  userUpdateVehicle: userUpdateVehicle,
  userDeleteVehicle: userDeleteVehicle,
  userMatrixVehicle: userMatrixVehicle,
  userMoreVehicle: userMoreVehicle,
  userDriver: userDriver,
  userAddDriver: userAddDriver,
  userUpdateDriver: userUpdateDriver,
  userTicketDriver: userTicketDriver,
  userMatrixDriver: userMatrixDriver,
  userMoreDriver: userMoreDriver,
  userCompliance: userCompliance,
  userAddCompliance:userAddCompliance,
  userUpdateCompliance: userUpdateCompliance,
  userOnBoardCompliance: userOnBoardCompliance,
  userAddOnBoardCompliance:userAddOnBoardCompliance,
  gstCompany:gstCompany,
  updateCompany:updateCompany,
  updateGstCompany:updateGstCompany,
  userChooseYourService:userChooseYourService,
  userUpdateChooseYourService:userUpdateChooseYourService,
  companyEmployees: getEmployeesList,
  getReservationList: getReservationList,
  getBookingBufferTime: getBookingBufferTime,
  getAirportTerminalList: getAirportTerminalList,
  getReservationDetails: getReservationDetails,
  addReservation:addReservation,
  updateReservation:updateReservation,
  allotVehicle: allotVehicle,
  getBillingList: getBillingList,
  getBillingInvoiceDetails: getBillingInvoiceDetails,
  getBillingPriceDetails: getBillingPriceDetails,
  getBillingChargesCalculations: getBillingChargesCalculations,
  addBillingRequestApproval: addBillingRequestApproval,
  addBillingConsolidatedInvoice: addBillingConsolidatedInvoice,
  getAvailableVehicle: getAvailableVehicle,
  availableSuppliers: getAvailableSuppliers,
  dispatchVehicle: dispatchVehicle,
  cancelTrip: cancelTrip,
  cancelationTripCharges: getCancelTripCharges,
  getBookingMatrix: getBookingMatrix,
  userVendor: userVendor,
  userAddVendor: userAddVendor,
  userUpdateVendor: userUpdateVendor,
  userVendorUser:userVendorUser,
  userPlaceDetails:userPlaceDetails,
  userProfile: userProfile,
  userUpdatProfile: userUpdateProfile,
  userAutoComplete:userAutoComplete,
  userDirection:userDirection,
  userGeocode:userGeocode,
  getSettlementList: getSettlementList,
  getSettlementDetails: getSettlementDetails,
  addSettlement: addSettlement,
  updateSettlement: updateSettlement,
  userAssignVehicle:userAssignVehicle,
  userListAssignedVehicle:userListAssignedVehicle,
  userRequestVehicle:userRequestVehicle,
  userUpdateAssignDriver :userUpdateAssignDriver, 
  userUpdateAssignVehicle : userUpdateAssignVehicle,
  userAssignDriver:userAssignDriver,
  userUpdateAssignSubVendor:userUpdateAssignSubVendor,
  getBookingReportList:getBookingReportList,
  getCustomerMatrix:getCustomerMatrix,
  getCustomerList:getCustomerList,
  getRevenueList:getRevenueList,
  getRevenueMatrix:getRevenueMatrix,
  addMagicToken:addMagicToken,
  verifyMagicToken:verifyMagicToken,
  getDownLoadList:getDownLoadList,
  userGetTripPrice:userGetTripPrice,
  getRevenueDownLoad:getRevenueDownLoad,
  userTopCompanies:userTopCompanies,
  userCompanyTripStats:userCompanyTripStats,
  userCompanyData:userCompanyData,
  getCancelReason: getCancelReason,
  getConsolidateInvoiveList:getConsolidateInvoiveList,
  getBillingConsolidatedInvoiceDetails: getBillingConsolidatedInvoiceDetails,
  userCompanyDuty:userCompanyDuty,
  userCompanyLocation: userCompanyLocation,
  getMisList:getMisList,
  userLogout: userLogout,
  userCarFacilities:userCarFacilities,
  getConsolidateInvoiceMatrix:getConsolidateInvoiceMatrix,
  userConfigCompliance:userConfigCompliance,
  getSupplierRole:getSupplierRole,
  getAdminUser:getAdminUser,
  userUpdateAdminUser:userUpdateAdminUser,
  userAddAdminUser:userAddAdminUser,
  userAddCar:userAddCar,
  userUpdateCar:userUpdateCar,
  userDeleteCar:userDeleteCar,
  userFacilities:userFacilities,
  userAddTag:userAddTag,
  userRating:userRating,
  userTag:userTag,
  userUpdateTag:userUpdateTag,
  userAddFaq:userAddFaq,
  userDeleteFaq:userDeleteFaq,
  userFaq:userFaq,
  userFaqSection:userFaqSection,
  userUpdateFaq:userUpdateFaq,
  getFinalInvoice:getFinalInvoice,
  userParentCompanyDetails:userParentCompanyDetails,
  getMisReportDownLoad:getMisReportDownLoad,
  userRideDetailsPolylines:userRideDetailsPolylines,
  userNotification: userNotification,
  userNotificationCount: userNotificationCount,
  userNotificationSeen: userNotificationSeen,
  userSubCity: userSubCity,
  addBillingRequestApprovalLink:addBillingRequestApprovalLink,
  userComplianceValidation: getComplianceValidation,
  userCustomerComplaints: userCustomerComplaints,
  userCustomer: userCustomer,
  userMatrixCustomer: userMatrixCustomer,
  userTicketCustomer: userTicketCustomer,
  userUpdateCustomer: userUpdateCustomer,
  locationDropdown: locationDropdownReducer,
  userCoupon: userCoupon,
  userAddCoupon: userAddCoupon,
  userUpdateCoupon: userUpdateCoupon,
  userDeleteCoupon: userDeleteCoupon
});

export default rootReducer;
